module.exports = __webpack_public_path__ + "img/logo_oms.4c1376e4.svg";